'use strict';
/**
 * Created by Qui Huynh on 19/10/2017.
 */
angular
    .module('app.detailInfluencerGroup')
    .controller('DemoGraphicModalCtrl', [
        '$state',
        '$scope',
        '$rootScope',
        '$modalInstance',
        '$modal',
        'detailInfluencerGroupService',
        'influencer',
        function ($state, $scope, $rootScope, $modalInstance, $modal, detailInfluencerGroupService, influencer) {
            var me = this,
                CHART_COLORS = ['#26e09b', '#25d2eb', '#fd6e9d', '#c167c9', '#fdd953', '#1fb4f6', '#f94240', '#c8cdd5'],
                MSG = {
                    LOADING: 'Fetching data, please wait.',
                    NO_DATA: 'Demographics data is not available for this influencer.',
                    ERROR: 'An error occurred. Please try again later.',
                },
                MAX_TOP_ITEM = 10;

            
            var showError = function(error) {
                $rootScope.handleRequestError({message: error}, $scope);
            };

            var closeModal = function() {
                $modalInstance.close();
            };

            var getInfluencerData = function(id) {
                detailInfluencerGroupService.getInfluencerDemoGraphicData(id, false) 
                    .then(function(res){
                        var payload = res;
                        if (payload) {
                            me.chartVisible = true;
                            data = {
                                content_persons_statistic: JSON.parse(payload.audienceData.content_persons_statistic),
                                content_geo_statistic: JSON.parse(payload.audienceData.content_geo_statistic),
                                audience_interests: JSON.parse(payload.audienceData.audience_interests),
                                audience_languages: JSON.parse(payload.audienceData.audience_languages),
                                brand_affinity: JSON.parse(payload.audienceData.brand_affinity),
                                audience_brand_affinity: JSON.parse(payload.audienceData.audience_brand_affinity),
                            };
                            processChart();
                        }
                        else {
                            me.msg = MSG.NO_DATA;
                        }
                    }, function (err) {
                        me.msg = MSG.ERROR;
                        $rootScope.handleRequestError(err, $scope);
                    });
            };

            var data = {};

            var pieChartConf = {
                options: {
                    chart: {
                        type: 'pie',
                        backgroundColor: null,
                        width: 400,
                        height: 230,
                        style: {
                            fontFamily: 'ProximaNovaRegular',
                        }
                    },
                    colors: CHART_COLORS,
                    tooltip: {
                        enabled: false
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: false,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    legend: {
                        symbolHeight: 12,
                        symbolWidth: 12,
                        symbolRadius: 6,
                        verticalAlign: 'middle',
                        align: 'right',
                        layout: 'vertical',
                        width: 170,
                        padding: 5,
                        itemMarginBottom: 5,
                        itemStyle: {
                            fontWeight: '500',
                            color: '#a0a9b7',
                        },
                        labelFormatter: function () {
                            var text = angular.copy(this.name);
                            if (text.length > 14) {
                                text = text.slice(0, 12) + '...';
                            }

                            return '<span style="display: block">'
                              + '<span>' + text + ' ' + '</span>'
                              + '<b>'+ Math.round(this.y*1000)/10 +'%' + '</b>'
                              + '</span>';}
                    }
                },
                series: [{
                    size: '100%',
                    innerSize: '87%'
                }],
                title: {
                    text: 'Chart',
                    style: {
                        fontSize: '14px',
                        color: '#7d8490',
                        fontFamily: 'ProximaNovaSemibold'
                    },
                    align: 'left'
                },
                xAxis: {
                    type: 'datetime',
                    title: {
                        text: 'Date'
                    }
                },
                noData: 'Pending Data...',
                loading: true
            };

            var categories = ['10-19', '20-29', '30-39', '40-49'];

            var barChartConf = {
                options: {
                    chart: {
                        type: 'bar',
                        width: 693,
                        height: 300,
                        style: {
                            fontFamily: 'ProximaNovaRegular',
                        }
                    },
                    colors: CHART_COLORS,
                    tooltip: {
                        enabled: false
                    },
                    plotOptions: {
                        bar: {
                            allowPointSelect: false,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                formatter: function() {
                                    return '<span style="color: #a0a9b7; font-weight: bold;">' + Math.abs(this.y) + '%'+ '</span>';
                                },
                                inside: false,
                                padding: 10,
                                y: -1
                            },
                            showInLegend: true
                        },
                        series: {
                            stacking: 'normal'
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    legend: {
                        symbolHeight: 12,
                        symbolWidth: 12,
                        symbolRadius: 6,
                        align: 'center',
                        itemStyle: {
                            fontWeight: '500',
                            color: '#a0a9b7',
                            fontFamily: 'ProximaNovaRegular',
                        },
                        x: 30
                    }
                },
                xAxis: {
                    categories: [],
                    title: {
                        /*text: 'Age'*/
                    }
                },
                yAxis: {
                    visible: false,
                    title: {
                        text: null
                    },
                    labels: {
                        formatter: function () {
                            return Math.abs(this.value);
                        }
                    }
                },
                series: [],
                title: {
                    text: 'Chart',
                    style: {
                        fontSize: '14px',
                        color: '#7d8490',
                        fontFamily: 'ProximaNovaSemibold'
                    },
                    align: 'left'
                },
                noData: 'Pending Data...',
                loading: true
            };

            var mapGenderPerAgeSeries = function (data) {
                var result = [
                    {
                        name: 'Female',
                        data: []
                    },
                    {
                        name: 'Male',
                        data: []
                    }
                ];
                angular.forEach(data, function(value, key) {
                    this[0].data.push(-Math.round(data[key].FEMALE*1000)/10); 
                    this[1].data.push(Math.round(data[key].MALE*1000)/10);
                }, result);
                return result;  
            };

            var mapKeyInObjectIntoArray = function (data) {
                var result = [];
                angular.forEach(data, function(value, key) {
                    this.push(key);
                }, result);
                return result;
            };

            var mapObjectDataToArrayData = function (data) {
                var result = [];
                angular.forEach(data, function(value, key) {
                    this.push({name: key, y: value});
                }, result);
                return result;
            };

            var processBranAffinityData = function (data) {
                var result = [],
                    temp = [];
                angular.forEach(data, function(value, key) {
                    angular.forEach(value, function(value1, key1) {
                        // check duplicate
                        var isDuplicated = false;
                        for (var iT=0; iT<temp.length; iT++) {
                            if (temp[iT].name === key1) {
                                isDuplicated = true;
                                break;
                            }
                        };
                        if (!isDuplicated) {
                            temp.push({name: key1, value: value1});
                        }
                    });
                });

                temp.sort(function(a, b){return b.value-a.value});    
                var top20 = temp.slice(0, 20);

                for (var i=0; i<top20.length; i++) {
                    //result.push(temp[i].name + ' : ' + Math.round(temp[i].value*10000)/100 + '%' );
                    result.push(temp[i].name);
                };
                
                return result;
            };

            var filterCodeConstanst = function (data, constants) {
                for (var i=0; i< data.length; i++) {
                    for (var j=0; j <constants.length; j++) {
                        if (data[i].name === constants[j].code) {
                            data[i].name = constants[j].name;
                            break;
                        }
                    }
                }
                return data;
            };

            var calculateTopItem = function (data) {
                var newData,
                    totalPercent = 0;
                if (data.length > MAX_TOP_ITEM ) {
                    newData = data.slice(0, MAX_TOP_ITEM);
                    for (var i=0; i<newData.length; i++) {
                        totalPercent = totalPercent + newData[i].y; 
                    }
                    for (var j=0; j<newData.length; j++) {
                        newData[j].y = newData[j].y * (100/(totalPercent*100));
                    }
                }
                else {
                    newData = data;
                }
                return newData;
            };

            var getMaxNumberOfGenderPerAge = function (data) {
                var max = 0;
                var left = data[0].data;
                var right = data[1].data;
                for (var i=0; i<left.length; i++) {
                    if ((-left[i]) > max) {
                        max = -left[i];
                    }
                }
                for (var j=0; j<right.length; j++) {
                    if (right[j] > max) {
                        max = right[j];
                    }
                }
                return max;
            };

            var processChart = function () {
                var genderChartConf = angular.copy(pieChartConf);
                //genderChartConf.series[0].data = [{name: 'Male', y: 0.3}, {name: 'Female', y: 0.7}];
                genderChartConf.series[0].data = mapObjectDataToArrayData(data.content_persons_statistic.genders);
                for(var i=0; i< genderChartConf.series[0].data.length; i++) {
                    if (genderChartConf.series[0].data[i] && genderChartConf.series[0].data[i].name === 'MALE') {
                        genderChartConf.series[0].data[i].name = 'Male';
                    }
                    if (genderChartConf.series[0].data[i] && genderChartConf.series[0].data[i].name === 'FEMALE') {
                        genderChartConf.series[0].data[i].name = 'Female';
                    }
                }
                genderChartConf.title.text = 'GENDER';

                var countryChartConf = angular.copy(pieChartConf);
                //countryChartConf.series[0].data = [{name: 'Denmark', y: 0.3}, {name: 'Germany', y: 0.3}, {name: 'Germany', y: 0.2}, {name: 'Germany', y: 0.1}, {name: 'Germany', y: 0.1}];
                countryChartConf.series[0].data = calculateTopItem(mapObjectDataToArrayData(data.content_geo_statistic.countries));
                countryChartConf.series[0].data = filterCodeConstanst(countryChartConf.series[0].data, me.def.countries);
                countryChartConf.title.text = 'COUNTRIES';
                
                var audienceInterestChartConf = angular.copy(pieChartConf);
                //audienceInterestChartConf.series[0].data = [{name: 'Tech', y: 0.3}, {name: 'Hotel', y: 0.3}, {name: 'Mobile', y: 0.2}, {name: 'Computer', y: 0.1}];
                audienceInterestChartConf.series[0].data = calculateTopItem(mapObjectDataToArrayData(data.audience_interests));
                audienceInterestChartConf.title.text = 'AUDIENCE INTERESTS';

                var nativeChartConf = angular.copy(pieChartConf);
                //nativeChartConf.series[0].data = [{name: 'Danish', y: 0.1}, {name: 'English', y: 0.1}, {name: 'German', y: 0.2}, {name: 'Laos', y: 0.1}, {name: 'VN', y: 0.1}, {name: 'ABC', y: 0.1}, {name: 'DDD', y: 0.2}, {name: 'XXX', y: 0.1}];
                nativeChartConf.series[0].data = calculateTopItem(mapObjectDataToArrayData(data.audience_languages));
                nativeChartConf.series[0].data = filterCodeConstanst(nativeChartConf.series[0].data, me.def.languages);
                nativeChartConf.title.text = 'NATIVE LANGUAGES';

                var genderPerAgeChartConf = angular.copy(barChartConf);
                genderPerAgeChartConf.title.text = 'GENDER PER AGE';
                genderPerAgeChartConf.xAxis.categories = mapKeyInObjectIntoArray(data.content_persons_statistic.gendersPerAge);
                genderPerAgeChartConf.series = mapGenderPerAgeSeries(data.content_persons_statistic.gendersPerAge);
                genderPerAgeChartConf.yAxis.max = (getMaxNumberOfGenderPerAge(genderPerAgeChartConf.series) + 5);
                genderPerAgeChartConf.yAxis.min = -genderPerAgeChartConf.yAxis.max;

                //var brandAffinity = ["Apple", "Nike", "GShock", "aaa", "vvvv", "Apple", "Nike", "GShock", "aaa", "vvvv", "Apple", "Nike", "GShock", "aaa", "vvvv", "Apple", "Nike", "GShock", "aaa", "vvvv", "Apple", "Nike", "GShock", "aaa", "vvvv", "Apple", "Nike", "GShock", "aaa", "vvvv", "Apple", "Nike", "GShock", "aaa", "vvvv"];
                var brandAffinity = processBranAffinityData(data.audience_brand_affinity);

                me.genderChartConf = genderChartConf;
                me.countryChartConf = countryChartConf;
                me.genderPerAgeChartConf = genderPerAgeChartConf;
                me.audienceInterestChartConf = audienceInterestChartConf;
                me.nativeChartConf = nativeChartConf;
                me.brandAffinity = brandAffinity;

            };

            (function init() {
                me.chartVisible = false;
                me.msg = MSG.LOADING;
                me.def = angular.copy($rootScope.definitions);
                var data = {};
                getInfluencerData(influencer.influencerId);
                //getInfluencerData(2832215);
                me.closeModal = closeModal;
                me.influencerName = influencer.influencerName;

            })();
        }
]);